module.exports = require('./assets/vue-directive-image-previewer.js')
